'use strict';

var formValidation = require('./components/formValidation');
const returnTimer = require('./countDownTimer');
var validator = require('./validator');
var createAccErrorMessages = {};
var populateErrorMessages = require('./validationMessage');
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');
window.sessionStorage.removeItem('placeOrder');
var utils = require('./utils');

$(document).ready(function () {
    var accountPresent = $('.order-placed-create-account').attr('data-ispresent');
    if (accountPresent) {
        tealiumEnable.getAnalyticsData('accountRegisterOnload');
    }
    var $createAccFormOrderPlaced = $('.checkout-registration');
    var $FirstName = $createAccFormOrderPlaced.find('#registration-form-fname');
    var $LastName = $createAccFormOrderPlaced.find('#registration-form-lname');
    var $Email = $createAccFormOrderPlaced.find('#registration-form-email');
    var $Password = $createAccFormOrderPlaced.find('#registration-form-password');
    populateErrorMessages(createAccErrorMessages, $FirstName);
    populateErrorMessages(createAccErrorMessages, $LastName);
    populateErrorMessages(createAccErrorMessages, $Email);
    populateErrorMessages(createAccErrorMessages, $Password);
    validator.init($createAccFormOrderPlaced, {
        ...validator.ONKEYUP_ONFOCUSOUT_SETTINGS,
        ...validator.ENABLED_BUTTON_SETTINGS,
        messages: createAccErrorMessages
    });

    // eslint-disable-next-line
    var optMailCheckout = cookieSet.get('optMailCheckout');
    if (optMailCheckout && optMailCheckout === 'true') {
        // eslint-disable-next-line
        var optEmail = cookieSet.get('optEmail');
        let dataURL = $('#optInEmail').data('action');
        $.ajax({
            url: dataURL,
            type: 'post',
            dataType: 'json',
            data: { email: optEmail }
        });
    }
    // eslint-disable-next-line
    cookieSet.delete('optMailCheckout');
    // eslint-disable-next-line
    cookieSet.delete('optEmail');

    $('form.checkout-registration .btn-createAcc-order-placed').on('click', function () {
        if ($(this).closest('form.checkout-registration').find('.form-password.ds-textfield__input').val() === '') {
            let pwdErrormsg = $('form.checkout-registration').find('#ds-password-error').data('ocpemptypwderror');
            $(this).closest('form.checkout-registration').find('#ds-password-error').empty()
            .text(pwdErrormsg)
            .show();
        } else {
            var form = $(this).closest('.checkout-registration');
            var passwordValue = form.find('#ds-password').val();
            var validationResult = utils.passwordOnSubmitValidation(passwordValue);
            setTimeout(function () {
                var errorList = validationResult.errorMessage;
                if (!validationResult.isFormValid && passwordValue !== '') {
                    form.find('.ds-rules-message').addClass('d-none');
                    form.find('#ds-password-error').empty().show();
                    form.find('#ds-password').addClass('error is-invalid');
                    errorList.forEach(function (item) {
                        form.find('#ds-password-error').append(`<p class="error-extended">${item}</p>`);
                    });
                }
            }, 10);
        }
    });

    $('form.checkout-registration').submit(function (e) {
        e.preventDefault();
        var form = $(this);
        var passwordValue = form.find('#ds-password').val();
        var validationResult = utils.passwordOnSubmitValidation(passwordValue);
        setTimeout(function () {
            var errorList = validationResult.errorMessage;
            if (!validationResult.isFormValid && passwordValue !== '') {
                form.find('.ds-rules-message').addClass('d-none');
                form.find('#ds-password-error').empty().show();
                form.find('#ds-password').addClass('error is-invalid');
                errorList.forEach(function (item) {
                    form.find('#ds-password-error').append(`<p class="error-extended">${item}</p>`);
                });
            }
        }, 10);
        if (!form.valid() || !validationResult.isFormValid) {
            form.find('input.is-invalid').not('#ds-password').first().focus();
        } else {
            var url = form.attr('action');
            form.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                        tealiumEnable.getAnalyticsData('serverError', data.errorCode);
                    } else {
                        var toastMessage = $('button.btn-createAcc-order-placed').data('toastmsg');
                        // location.href = data.redirectUrl;
                        var redirectUrl = $('.btn-createAcc-order-placed').data('urlredirect');
                        location.href = redirectUrl;
                        $('html, body').animate({
                            scrollTop: $('.acc-created').offset().top
                        }, 500);
                        var addtoemaillist = data.addtoemaillist;
                        utils.showConfirmToast(toastMessage);
                        tealiumEnable.getAnalyticsData('creatAccountAndLoginEvent', 'orderConfirmation', addtoemaillist);
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    form.spinner().stop();
                }
            });
        }
        return false;
    });

    setInterval(function () {
        var $editCancelOrderContainer = $('.edit-cancel-order');
        var orderCreationDate = $editCancelOrderContainer.data('ordercreation');
        var defaultTimeValue = $editCancelOrderContainer.data('expirationtimer');
        var leftTime = returnTimer(defaultTimeValue, orderCreationDate);
        $('.countdown').html(leftTime);
        if (leftTime === 0) {
            $('.edit-cancel-order').fadeOut('slow');
        }
    }, 1000);
});
